import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import IntlMessage from '../../../../../helpers/intlMessage';

import TableReport from '@componentes/TableReport';

function Especial ({ lista, isDescarte = true }) {

  const headerListItens = [
    <IntlMessage id = "dashboards.reports.exam"/>,
    <IntlMessage id = "dashboards.reports.bottle"/>,
    <IntlMessage id = "dashboards.reports.patientCivilRegistry"/>,
    <IntlMessage id = "dashboards.reports.socialName"/>,
    <IntlMessage id = "dashboards.reports.material"/>,
    <IntlMessage id = "dashboards.reports.deliverydates"/>,
    <IntlMessage id = "dashboards.reports.discardRequestingPhysician"/>,
    <IntlMessage id = "dashboards.reports.discardDate"/>,
    <IntlMessage id = "dashboards.reports.deliveryDate"/>
  ];

  const [headerList, setHeaderList] = useState(headerListItens);
  const [listaFormatada, setListaFormatada] = useState([]);
  const [titulo, setTitulo] = useState('');
  const [mostrarDataEntrega, setMostrarDataEntrega] = useState(true);
  const [mostrarDataDescarte, setMostrarDataDescarte] = useState(true);

  const tab = useSelector(state => state.descarteCommon.tab);

  useEffect(() => {
    carregarTitulo();
  }, [tab]);

  useEffect(() => {
    let listTiles = headerListItens;
    if (mostrarDataDescarte) {
      listTiles[7] = <IntlMessage id = "dashboards.reports.discardDate"/>;
    } else {
      listTiles.splice(7,7);
    }

    if (mostrarDataEntrega) {
      listTiles[8] = <IntlMessage id = "dashboards.reports.deliveryDate"/>;
    } else {
      listTiles.splice(8,8);
    }
    setHeaderList(listTiles);
  }, [mostrarDataEntrega, mostrarDataDescarte]);

  useEffect(() => {
    formatList(lista);
  }, [lista]);

  useEffect(() => {
    verificarMostrarDataEntrega();
    verificarMostrarDataDescarte();
  }, [listaFormatada]);

  function formatList (list) {
    const relatorioListaFormated = list.map(item => ({
      ...item,
      medicoResponsavelDescarte: item.medicoResponsavelDescarteId
        ? `${item.medicoResponsavelDescarteId} ${item.medicoResponsavelDescarte}`
        : ''
    }));
    setListaFormatada(relatorioListaFormated);
  }

  function carregarTitulo () {
    if (!isDescarte) {
      setTitulo(<IntlMessage id = "dashboards.reports.materialSpecial"/>);
    } else {
      setTitulo(<IntlMessage id = "dashboards.reports.specialRecord"/>);
    }
  }

  function verificarMostrarDataEntrega () {
    const mostrar =
      listaFormatada.map((elem, i) => elem.dataEntrega !== '').indexOf(true) >
      -1;
    setMostrarDataEntrega(mostrar);
  }

  function verificarMostrarDataDescarte () {
    const mostrar =
      listaFormatada.map((elem, i) => elem.dataDescarte !== '').indexOf(true) >
      -1;
    setMostrarDataDescarte(mostrar);
  }

  return (
    <TableReport
      title={titulo}
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
      headerList={headerList}
    >
      {listaFormatada.map((item, i) => (
        <tr key={i}>
          <td>{item.numeroExame}</td>
          <td>{item.idFrasco}</td>
          <td>{item.paciente}</td>
          <td>{item.pacienteNomeSocial}</td>
          <td>{item.nomeMaterial}</td>
          <td>{item.dataRecebimento}</td>
          <td>{item.medicoResponsavelDescarte}</td>
          {mostrarDataDescarte && <td>{item.dataDescarte}</td>}
          {mostrarDataEntrega && <td>{item.dataEntrega}</td>}
        </tr>
      ))}
    </TableReport>
  );
}

Especial.propTypes = {
  lista: PropTypes.array.isRequired
};

Especial.defaultProps = {
  lista: []
};

export default Especial;



// WEBPACK FOOTER //
// ./src/pages/descarte/common/components/Especial/index.js